import ProgressDialog, { ProgressDialogProps } from "@components/ProgressDialog"
import { Button, TextField } from "@mui/material"
import { FunctionComponent, useRef } from "react"
import { useCreateSnapshotMutation } from "@store/services/snapshotService"
import { enqueueSnackbar } from "notistack"

type Props = Pick<ProgressDialogProps, "onClose"> & {
  graphKey: string
}

const SnapshotSaveDialog: FunctionComponent<Props> = (props) => {
  const [saveSnapshot, { isLoading }] = useCreateSnapshotMutation()
  const messageRef = useRef<HTMLInputElement>()

  const handleSaveSnapshot = async () => {
    if (!messageRef.current || messageRef.current?.value === "") {
      enqueueSnackbar("Empty message", { variant: "error" })
      return
    }
    try {
      const resp = await saveSnapshot({
        key: props.graphKey,
        message: messageRef.current.value,
      }).unwrap()
      enqueueSnackbar(resp.message, { variant: "success" })
      props.onClose()
    } catch (e) {
      enqueueSnackbar("Problem saving snapshot", { variant: "error" })
    }
  }

  return (
    <ProgressDialog
      isLoading={isLoading}
      open={true}
      onClose={props.onClose}
      title="Snapshot create"
      actionsComponent={
        <>
          <Button variant="contained" onClick={handleSaveSnapshot} disabled={isLoading}>
            Save
          </Button>
        </>
      }
    >
      <TextField label="Message" inputRef={messageRef} variant="standard" sx={{ spacing: 2 }} />
    </ProgressDialog>
  )
}

export default SnapshotSaveDialog
